var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyepassowrd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eye_passowrd",
    "data-name": "eye passowrd",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_124",
    "data-name": "Rectangle 124",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M17.382,18.76a10.674,10.674,0,0,1-16.2-7.078A10.653,10.653,0,0,1,4.42,5.8L1.387,2.765,2.759,1.394,21.965,20.6l-1.372,1.372ZM5.793,7.171a8.7,8.7,0,0,0-2.632,4.511,8.734,8.734,0,0,0,12.806,5.663L14,15.378a4.366,4.366,0,0,1-6.02-6.02Zm6.769,6.769L9.418,10.8a2.427,2.427,0,0,0,3.144,3.144Zm7.656,2.2-1.388-1.388a8.667,8.667,0,0,0,1.36-3.067A8.737,8.737,0,0,0,9.3,5.22L7.771,3.689a10.68,10.68,0,0,1,14.4,7.993A10.619,10.619,0,0,1,20.219,16.137ZM11.407,7.325q.133-.008.269-.008a4.365,4.365,0,0,1,4.365,4.365q0,.135-.008.269Z",
    transform: "translate(0.324 0.317)",
    fill: "#c6c6c6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyepassowrd);
export default __webpack_public_path__ + "static/media/eye passowrd.9ca4e41ba7a3587250230b4c1b2ca2f5.svg";
export { ForwardRef as ReactComponent };